// As we're using immer
import { createSlice } from '@reduxjs/toolkit';
const INITIAL_STATE = {
    active: null,
    activeHighlightsData: {},
    items: [],
    loading: true
};
const StatusUpdatesSlice = createSlice({
    name: 'statusUpdates',
    initialState: INITIAL_STATE,
    reducers: (create)=>({
            setStatusUpdates: create.reducer((state, action)=>{
                state.items = action.payload;
                state.loading = false;
                if (!state.active) {
                    state.active = action.payload[0] || null;
                }
            }),
            appendStatusUpdate: create.reducer((state, action)=>{
                state.items.push(action.payload);
            }),
            updateStatusUpdate: create.reducer((state, action)=>{
                state.items = state.items.reduce((acc, item, index)=>{
                    if (item.statusUpdateId === action.payload.statusUpdateId) {
                        acc.push({
                            ...state.items[index],
                            ...action.payload
                        });
                    } else {
                        acc.push(state.items[index]);
                    }
                    return acc;
                }, []);
                state.loading = false;
            }),
            setStatusUpdatesLoading: create.reducer((state, action)=>{
                state.loading = action.payload;
            }),
            setActiveStatusUpdate: create.reducer((state, action)=>{
                state.active = {
                    ...action.payload,
                    collaborators: action.payload.collaborators || []
                };
            }),
            setActiveStatusUpdateTitle: create.reducer((state, action)=>{
                if (state.active === null) {
                    return;
                }
                state.active.statusUpdateTitle = action.payload;
            }),
            setActiveStatusUpdateHighlightsData: create.reducer((state, action)=>{
                state.activeHighlightsData = {
                    ...state.activeHighlightsData,
                    ...action.payload
                };
            }),
            removeStatusUpdate: create.reducer((state, action)=>{
                state.items = state.items.filter((item)=>item.statusUpdateId !== action.payload.statusUpdateId);
                const firstStatusUpdate = state.items[0];
                state.active = firstStatusUpdate;
            })
        })
});
export const selectStatusLoading = (state)=>state.statusUpdates.loading;
export const selectStatusUpdates = (state)=>state.statusUpdates.items;
export const selectActiveStatusUpdate = (state)=>{
    return state.statusUpdates.active;
};
export const selectActiveStatusUpdateHighlightTasks = (state)=>{
    return state.statusUpdates.activeHighlightsData;
};
// TODO: Check whether I need this. let saga take care of this?
export const { setStatusUpdates, appendStatusUpdate, updateStatusUpdate, setStatusUpdatesLoading, setActiveStatusUpdate, setActiveStatusUpdateTitle, setActiveStatusUpdateHighlightsData, removeStatusUpdate } = StatusUpdatesSlice.actions;
export const statusUpdatesReducer = StatusUpdatesSlice.reducer;
